import { ActionReducerMap } from '@ngrx/store';
import * as fromEtl from '@etl/etl.reducer';
import * as fromParameter from '@parameter/store/parameter.reducer';
import * as fromWorkbook from '@workbook/store/workbook.reducer';
import * as fromView from '@view/store/view.reducer';
import * as fromRole from '@role/store/role.reducer';

export interface RootState {
  global: object;
  etl: fromEtl.EtlState;
  parameter: fromParameter.ParameterState;
  workbook: fromWorkbook.WorkbookState;
  view: fromView.ViewState;
  role: fromRole.RoleState;
}

export const rootReducers: ActionReducerMap<RootState> = {
  global: null,
  etl: fromEtl.reducer,
  parameter: fromParameter.reducer,
  workbook: fromWorkbook.reducer,
  view: fromView.reducer,
  role: fromRole.reducer,
};
